const sh = require('shelljs')
const { config } = require('../common.js')

module.exports = yargs => {
	sh.exec(`cd ${ config.get("ops_client_path")} && yarn run dist`)
}



// WEBPACK FOOTER //
// ./src/commands/dist.js